export default "__VITE_ASSET__Cp6lZgQe__"